/**
 * Session storage key prefix used by the public onboarding flow's
 * Onboarding.Wrapper (routes/public/index.tsx).
 *
 * Lives here, free of React and route imports, so pre-render code can read the
 * persisted onboarding state without pulling in the onboarding tree.
 */
export const onboardingStorePrefix = 'onboarding';

export const onboardingStateStorageKey = `${onboardingStorePrefix}::state`;
